<template>

  <div class="ui grid animated fadeIn">

    <div class="nine wide computer sixteen wide tablet sixteen wide mobile column">

      <div class="ui segment">
        <h4 class="ui dividing header">Dados do Orçamento</h4>
        <form class="ui form">
          <div class="fields">            
            <div class="five wide field">
              <label>Status</label>
              <span v-if="isObject(quotation.statusData.description)">
                Antes:
                <i class="icon" :class="quotation.statusData.icon.__old + ' ' + quotation.statusData.color.__old"></i>
                {{ quotation.statusData.description.__old }}
              </span> 
              <p v-if="isObject(quotation.statusData.description)"></p> 
              <span>
                <i class="icon" 
                :class="[isObject(quotation.statusData.icon) ? quotation.statusData.icon.__new : quotation.statusData.icon] + ' ' +
                [isObject(quotation.statusData.color) ? quotation.statusData.color.__new : quotation.statusData.color]">
                </i>
                {{ isObject(quotation.statusData.description) ? quotation.statusData.description.__new : quotation.statusData.description }}
              </span>            
            </div>
            <div class="two wide field">
              <label>Número</label>
              <span v-if="isObject(quotation.id)">Antes: {{ quotation.id.__old }}</span>
              <p v-if="isObject(quotation.id)"></p>
              <span>{{ isObject(quotation.id) ? quotation.id.__new : quotation.id }}</span>              
            </div>
            <div class="three wide field">
              <label class="form-label">Data</label>
              <span v-if="isObject(quotation.date)">Antes: {{ $formatDate(quotation.date.__old) }}</span>
              <p v-if="isObject(quotation.date)"></p>
              <span>{{ isObject(quotation.date) ? $formatDate(quotation.date.__new) : $formatDate(quotation.date) }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Hora</label>
              <span v-if="isObject(quotation.time)">Antes: {{ quotation.time.__old }}</span>
              <p v-if="isObject(quotation.time)"></p>
              <span>{{ isObject(quotation.time) ? quotation.time.__new : quotation.time }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Alteração</label>
              <span v-if="quotation.canEdit"><i class="unlock icon"></i> Liberada</span>
              <span v-else><i class="lock red icon"></i> Bloqueada</span>
            </div>
          </div>
          <div class="fields">
            <div class="five wide field">
              <label class="form-label">Tipo</label>
              <div v-if="isObject(quotation.type)">
                <span v-if="quotation.type.__old == '1'" class="field">Antes: <i class="grey file icon"></i> Orçamento</span>
                <span v-if="quotation.type.__old == '2'" class="field">Antes: <i class="shopping cart teal icon"></i> Pedido</span>
                <span v-if="quotation.type.__old == '3'" class="field">Antes: <i class="gift red icon"></i> Bonificação</span>
                <p v-if="isObject(quotation.type)"></p>
                <span v-if="quotation.type.__new == '1'"><i class="grey file icon"></i> Orçamento</span>
                <span v-if="quotation.type.__new == '2'"><i class="shopping cart teal icon"></i> Pedido</span>
                <span v-if="quotation.type.__new == '3'"><i class="gift red icon"></i> Bonificação</span>
              </div>
              <div v-else>
                <span v-if="quotation.type == '1'"><i class="grey file icon"></i> Orçamento</span>
                <span v-if="quotation.type == '2'"><i class="shopping cart teal icon"></i> Pedido</span>
                <span v-if="quotation.type == '3'"><i class="gift red icon"></i> Bonificação</span>
              </div>
            </div>
            <div class="five wide field">
              <label class="form-label">Responsável</label>
              <span v-if="isObject(quotation.user.name)" class="field">Antes: {{ quotation.user.name.__old }}</span>
              <p v-if="isObject(quotation.user.name)"></p>
              <span>{{ isObject(quotation.user.name) ? quotation.user.name.__new : quotation.user.name }}</span>
            </div>
            <div v-if="quotation.approver" class="six wide field">
              <label class="form-label">Aprovador</label>
              <span v-if="isObject(quotation.approver.name)" class="field">{{ quotation.approver.name.__old }}</span>
              <p v-if="isObject(quotation.approver.name)"></p>
              <span>{{ isObject(quotation.approver.name) ? quotation.approver.name.__new : quotation.approver.name }}</span>
            </div>
          </div>
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Cliente</label>
              <span v-if="isObject(quotation.customer.name)" class="field">Antes: {{ quotation.customer.name.__old }} - {{ cnpjData }}</span>
              <p v-if="isObject(quotation.customer.name)"></p>
              <span>{{ isObject(quotation.customer.name) ? quotation.customer.name.__new : quotation.customer.name }} - {{ cnpjData }}</span>
            </div>
          </div>
          <div class="fields">
            <div class="seven wide field">
              <label class="form-label">Cond. Pagamento</label>
              <span v-if="isObject(quotation.descPayment)" class="field">Antes: {{ quotation.descPayment.__old }}</span>
              <p v-if="isObject(quotation.descPayment)"></p>
              <span>{{ isObject(quotation.descPayment) ? quotation.descPayment.__new : quotation.descPayment }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Frete</label>
              <span v-if="isObject(quotation.freight)" class="field">>Antes: {{ quotation.freight.__old == 'C' ? 'CIF' : 'FOB' }}</span>
              <p v-if="isObject(quotation.freight)"></p>
              <span>{{ isObject(quotation.freight) ? quotation.freight.__new == 'C' ? 'CIF' : 'FOB' : quotation.freight == 'C' ? 'CIF' : 'FOB' }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Venda Varejo</label>
              <span v-if="isObject(quotation.isRetail)" class="field">Antes: {{ quotation.isRetail.__old ? 'Sim' : 'Não' }}</span>
              <p v-if="isObject(quotation.isRetail)"></p>
              <span>{{ isObject(quotation.isRetail) ? quotation.isRetail.__new ? 'Sim' : 'Não' : quotation.isRetail ? 'Sim' : 'Não' }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Data Validade</label>
              <span v-if="isObject(quotation.validDate)" class="field">Antes: {{ $formatDate(quotation.validDate.__old) }}</span>
              <p v-if="isObject(quotation.validDate)"></p>
              <span>{{ isObject(quotation.validDate) ? $formatDate(quotation.validDate.__new) : $formatDate(quotation.validDate) }}</span>
            </div>
          </div>
          <div v-if="quotation.customer && quotation.customer.billBranchDesc && quotation.customer.code !== '000000' && !quotation.customer.isProspect" class="fields">
            <div class="five wide field">
              <label class="form-label">Fil. Faturamento</label>
              <span>{{ quotation.customer.billBranchDesc }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">ICMS</label>
              <span>{{ quotation.customer.icmsRate ? quotation.customer.icmsRate + '%' : '' }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Divide Pedido</label>
              <span>{{ quotation.customer.divideOrder ? 'Sim' : 'Não' }}</span>
            </div>
          </div>
          <div v-if="quotation.canceled" class="fields">
            <div class="seven wide field">
              <label class="form-label">Motivo Cancelamento</label>
              <span v-if="isObject(quotation.reasonCancel)" class="field">Antes: {{ quotation.reasonCancel.__old }}</span>
              <p v-if="isObject(quotation.reasonCancel)"></p>
              <span>{{ isObject(quotation.reasonCancel) ? quotation.reasonCancel.__new : quotation.reasonCancel }}</span>
            </div>
            <div class="nine wide field">
              <label class="form-label">Observações Cancelamento</label>
              <span v-if="isObject(quotation.cancelComments)" class="field">Antes: {{ quotation.cancelComments.__old }}</span>
              <p v-if="isObject(quotation.cancelComments)"></p>
              <span>{{ isObject(quotation.cancelComments) ? quotation.cancelComments.__new : quotation.cancelComments }}</span>
            </div>
          </div> 
        </form>
      </div>

      <quotation-totals :quotation="quotation" />

    </div>

    <div class="seven wide computer sixteen wide tablet sixteen wide mobile column">

       <div v-if="!canSeeRg()" class="ui segment">
        <h4 class="ui dividing header">Regras de Negócio</h4>
        <div class="ui accordion">
          <span v-for="rule in quotation.rules" :key="rule">
            <div class="title">
              <div> 
                <i class="dropdown icon"></i>
                {{ rule.description }}
                <i v-if="isObject(rule.isOk) && rule.isOk.__old" class="check circle green icon"></i>
                <i v-else-if="!isObject(rule.isOk) && rule.isOk" class="check circle green icon"></i>
                <i v-else class="exclamation circle red icon"></i>
                <i v-if="isObject(rule.isOk) && rule.isOk.__new" class="check circle green icon"></i>
                <i v-else-if="isObject(rule.isOk) && !rule.isOk.__new" class="exclamation circle red icon"></i>
              </div>
            </div>
            <div class="content">
              <p v-if="isObject(rule.comments)" class="grey text">Antes: {{ rule.comments.__old }}</p>
              <p class="grey text">{{ isObject(rule.comments) ? rule.comments.__new : rule.comments }}</p>
            </div>
          </span>          
        </div>
      </div>
      
      <div v-if="canSeeRg()" :class="quotation.aTaxinfo ? 'ui two column grid' : 'ui segment' ">
            <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
              <div class="ui segment">
                <h4 class="ui dividing header">Regras de Negócio</h4>
                <div class="ui accordion">
                  <span v-for="rule in quotation.rules" :key="rule">
                    <div class="title">
                      <div> 
                        <i class="dropdown icon"></i>
                        {{ rule.description }}
                        <i v-if="isObject(rule.isOk) && rule.isOk.__old" class="check circle green icon"></i>
                        <i v-else-if="!isObject(rule.isOk) && rule.isOk" class="check circle green icon"></i>
                        <i v-else class="exclamation circle red icon"></i>
                        <i v-if="isObject(rule.isOk) && rule.isOk.__new" class="check circle green icon"></i>
                        <i v-else-if="isObject(rule.isOk) && !rule.isOk.__new" class="exclamation circle red icon"></i>
                      </div>
                    </div>
                    <div class="content">
                      <p v-if="isObject(rule.comments)" class="grey text">Antes: {{ rule.comments.__old }}</p>
                      <p class="grey text">{{ isObject(rule.comments) ? rule.comments.__new : rule.comments }}</p>
                    </div>
                  </span>          
                </div>
              </div>
            </div>
            <div  v-if="quotation.aTaxinfo" class="eight wide computer sixteen wide tablet sixteen wide mobile column">
                 <tax-overview :quotation="quotation" />
            </div>
      </div>

      <div class="ui segment">
        <h4 class="ui dividing header">Concorrentes</h4>
        <table class="ui celled striped table">
          <tbody>
            <tr v-for="competitor in quotation.competitors">
              <td v-if="isObject(competitor.value)">Antes: {{ competitor.value.__old }}</td>
              <td>{{ isObject(competitor.value) ? competitor.value.__new : competitor.value }}</td>
            </tr>            
          </tbody>
        </table>
      </div>

      <div v-if="!quotation.isRevision" class="ui segment" :class="{ loading: loadingMessages }" style="min-height: 175px;">
        <h4 class="ui dividing header">Últimas mensagens</h4>
        <button class="ui mini basic button m-b-15" @click="onNewMessage()">
          <i class="plus blue icon"></i>
          Nova mensagem
        </button>
        <p v-if="quotation.messages.length == 0" class="grey text m-t-20" style="font-size: 13px;">Nenhuma mensagem</p>        
        <div v-else class="ui relaxed divided list">          
          <div v-for="(message, index) in quotation.messages" class="item" v-if="index <= 4">
            <div class="content">
              <div class="m-t-15">
                <a>{{ message.fromUserName }}</a>
                <span class="ui mini label m-l-10"><i class="check blue icon"></i> {{ message.when }}</span>
              </div>
              <div class="black text m-t-12" style="font-size: 14px;" v-html="message.subject"></div> 
              <div class="grey text m-t-10" style="font-size: 13px;" v-html="message.text"></div> 
            </div>
          </div>          
        </div>
      </div>

    </div>

  </div>

</template>

<script>

  import QuotationTotals from "./totals.vue"
  import TaxOverview from "./tax-overview.vue"
  import CnpjBusca from "@/services/cnpj-busca-service"
  import QuotationService from "@/services/quotation-service"

  export default {
    data() {
      return {
        cnpjData: ''
      }
    },
    props: ["quotation", "loadingMessages"],

    components: {
      QuotationTotals,
      TaxOverview
    },
    created() {
      if (this.quotation.codeCustomer === "000000") {
        this.buscaCnpj(this.quotation.CnpjPadrao)
      }
    },
    mounted() {
      $(".accordion").accordion()
    },

    methods: {
       canSeeRg() {
        return QuotationService.canSeeRg()
      },
      async buscaCnpj(cnpj) {
        let infoCnpj = ''
        if (cnpj.trim() !== '') {
          try {
            infoCnpj = await CnpjBusca.getDados(cnpj.trim())    
          } catch (error) {
            infoCnpj = error.request.responseText
          } finally {
            this.cnpjData = infoCnpj 
            return 
          }
        } else {
          this.cnpjData = ''
        }
      },
      isObject(value) {
        if (typeof value == "object" && value != null) {
          return true
        }
        return false
      },
      onNewMessage() {
        this.$emit("onNewMessage")
      }    
    },
  }

</script>
